import { format, parse } from "date-fns"; // Import date formatting utilities
import { fr } from "date-fns/locale"; // French locale (if needed for formatting)
import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument"; // Assuming you have a similar function to log actions
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken.js"; // Assuming you have this function to refresh tokens

const createNewEvent = async (
  starthour,
  endhour,
  startmin = 0,
  endmin = 0,
  date,
  name,
  description,
  master_id,
  prefix
) => {
  // Validate the duration and times
  const duration = endhour * 60 + endmin - starthour * 60 - startmin;

  if (
    duration > 0 &&
    starthour >= 7 &&
    starthour < 23 &&
    startmin >= 0 &&
    startmin < 60 &&
    endhour >= 7 &&
    endhour < 23 &&
    endmin >= 0 &&
    endmin < 60
  ) {
    try {
      // Parse the date string

      // Get Firebase token for authentication
      const token = await getOrRefreshFirebaseToken();
      const auth = getAuthCentral();
      const currentUser = auth.currentUser;

      if (!currentUser) {
        console.error("User not logged in");
        return "User not logged in";
      }

      // Prepare the request body
      // Get timezone offset in hours (accounts for DST automatically)
      const timezoneOffset = new Date().getTimezoneOffset() / 60;

      const body = {
        starthour: starthour + timezoneOffset,
        endhour: endhour + timezoneOffset,
        startmin: startmin,
        endmin: endmin,
        date: date,
        name: name,
        description: description,
        master_id: master_id,
      };

      // Define the endpoint URL
      const url = prefix + `events`;

      // Make the API request to create a new event
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body), // Encode the body as JSON
      });

      // Check if the request was successful
      if (!response.ok) {
        console.error(`Failed to create event: ${response.status}`);
        return null;
      }

      // Parse response as JSON
      const result = await response.json();

      // Get the Firestore user document for logging
      const db = getFirestore();
      const userRef = doc(db, "user", currentUser.uid);
      const userSnapshot = await getDoc(checkDB(userRef));

      if (!userSnapshot.exists()) {
        console.error("User document not found");
        return "";
      }

      const org_id = userSnapshot.get("org_id");

      // Log the request and response
      await addLogDocument(
        url,
        prefix,
        userRef,
        org_id,
        response.status.toString(),
        "", // folderid
        "", // docid
        JSON.stringify(body), // request body as string
        JSON.stringify(result) // Log the parsed JSON response
      );

      return result.event_id;
    } catch (error) {
      console.error("Error creating event:", error);
      return `Exception occurred: ${error.message}`;
    }
  } else {
    console.error("Invalid event times or duration. Event not created.");
    return null;
  }
};

export default createNewEvent;
